const _import = name => {
  return resolve => require([`../../views/${name}`], resolve)
}

const route = {
  path: '/home',
  component: _import('Home'),
  meta: {
    navShow: true,
    isRefreshAccount: true
  },
  name: 'Home'
}
export default route



// WEBPACK FOOTER //
// ./src/pages/build800/router/module/Home.js